/*
 * Extracts message from a HTTP response object.
 */
(function() {
    'use strict';

    angular.module('paysera.toast').factory('successMessageExtractor', successMessageExtractor);

    successMessageExtractor.$inject = ['messageResolver'];

    function successMessageExtractor(messageResolver) {
        return {
            extract: extract
        };

        function extract(response) {
            if (angular.isDefined(response.config)
                && response.config !== null
            ) {
                return parseDataObject(response.config);
            }
            return messageResolver.resolve('success', '');

            function parseDataObject(config) {
                var context = '';
                if (config.hasOwnProperty('success_context')) {
                    context = response.config['success_context'];
                }
                return messageResolver.resolve('success', context);
            }
        }
    }
})();
